import { AssetDTO } from '@gearbelt/global';
import { useQuery } from '@tanstack/react-query';

import documentstypesVector from '@/assets/vectors/documentstypes.svg';
import DownloadIcon from '@/components/icons/download';
import { getAWADocumentsByAssetQueryOptions } from '@/queries/documents';
import { getFileTypeIcon } from '@/utils/file-type';

export function AWAAssetDocuments({ asset }: { asset: AssetDTO }) {
  const { data: documentsData, isLoading: documentsLoading } = useQuery(getAWADocumentsByAssetQueryOptions({ assetId: asset.id ?? '' }));

  if (documentsLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="border-default-grey-2 border-t-default-blue size-[30px] animate-spin rounded-full border-4" />
      </div>
    );
  }

  if (documentsData?.data.length === 0) {
    return (
      <div className="flex h-full w-full flex-col items-center gap-2 px-2 py-25">
        <img src={documentstypesVector} alt="No activities yet" className="h-[170px] w-[250px]" />
        <div className="text-default-text text-center text-xl font-medium">No documents yet</div>
        <div className="text-secondary-text max-w-[500px] text-center text-base font-normal">
          Documents such as operating manuals, risk assessments, instructions and certificates can be uploaded via the Gearbelt website.
        </div>
      </div>
    );
  }

  return (
    <div className="border-grey-2 flex h-full w-full flex-col items-start border-t-2 p-0">
      {documentsData?.data.map((document) => (
        <div key={document.id} className="border-grey-2 flex h-[71px] w-full flex-col items-start border-b-2 bg-white p-0">
          <div className="flex h-[70px] w-full flex-row items-center gap-2.5 p-5">
            <div className="flex h-[30px] w-[30px] items-center justify-center">{getFileTypeIcon(document.mimeType ?? '')}</div>
            <div className="text-default-text w-full overflow-hidden text-base font-medium overflow-ellipsis whitespace-nowrap">{document.name}</div>
            <a href={document.presignedDownloadUrl ?? document.url} target="_blank" rel="noreferrer noopener">
              <DownloadIcon size={30} />
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}
